import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";


export async function getMonitorMeetingInfo(internalMeetingId: string) {
  const headers = userService.getAuthHeaders();
  const params = { mid: internalMeetingId };
  return JSON.parse((await axiosInstance.get("/ThongKe/GetMonitorMeetingInfo", { headers, params })).data.data).data;
}


export async function getMonitorUserInfo(mid: string, uid: string) {
  const headers = userService.getAuthHeaders();
  const params = { mid, uid };
  return JSON.parse((await axiosInstance.get("/ThongKe/GetMonitorUserInfo", { headers, params })).data.data).data.uinfo;
}
